import React, { Component } from 'react'


class Preview extends Component {

    render() {
        const wide = !!this.props.wide
        const width = wide ? '450px' : '200px'
        return (
            <img src={this.props.image} alt={`${this.props.image}`} style={{minWidth: width, maxWidth: width, height: 'auto'}} />
        )
    }

}


export default Preview



// WEBPACK FOOTER //
// ./src/components/preview.js